import { Building2, Handshake, LogOut } from "lucide-react";
import { AGENCY_BILLING_CONTACT_LABEL } from "@/lib/agency-billing";

export interface AgencyBillingBannerProps {
  message: string;
}

export function AgencyBillingBanner({ message }: AgencyBillingBannerProps) {
  return (
    <div role="alert" className="shadow-panel mx-3 mt-3 rounded-xl bg-amber-500/15 px-4 py-2.5 flex items-center gap-2 text-sm">
      <Handshake className="h-4 w-4 text-amber-600 shrink-0" aria-hidden="true" />
      <p className="text-amber-700 dark:text-amber-400 font-medium">
        {message} <span className="font-bold">{AGENCY_BILLING_CONTACT_LABEL}.</span>
      </p>
    </div>
  );
}

export interface AgencyBillingLockScreenProps {
  title: string;
  message: string;
  onSwitchWorkspace?: () => void;
  onSignOut: () => void;
}

export function AgencyBillingLockScreen({ title, message, onSwitchWorkspace, onSignOut }: AgencyBillingLockScreenProps) {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-5 max-w-md text-center p-8">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-amber-500/10">
          <Handshake className="h-10 w-10 text-amber-600" aria-hidden="true" />
        </div>
        <div>
          <h1 className="text-2xl font-bold font-display text-foreground mb-2">{title}</h1>
          <p className="text-muted-foreground text-sm">{message}</p>
          <p className="mt-3 text-sm font-semibold text-foreground">{AGENCY_BILLING_CONTACT_LABEL}.</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full">
          {onSwitchWorkspace && (
            <button
              type="button"
              onClick={onSwitchWorkspace}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-border text-sm font-medium hover:bg-accent transition-colors"
            >
              <Building2 className="h-4 w-4" aria-hidden="true" /> Cambiar workspace
            </button>
          )}
          <button
            type="button"
            onClick={onSignOut}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-border text-sm font-medium hover:bg-accent transition-colors"
          >
            <LogOut className="h-4 w-4" aria-hidden="true" /> Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}
